import { useAuth } from "@/providers";
import {
  useSearchTablePreferences,
  useUpdateSearchTablePreferences,
} from "@/shared/domain/config/hooks";

import {
  DEFAULT_ROWS_PER_PAGE,
  DEFAULT_TABLE_COLUMNS,
  TableType,
} from "./tablePreferencesConfig";
import {
  useCreatePreferenceCallbacks,
  createPreferencesWithDefaults,
  useOrgPreferences,
} from "./tablePreferencesHelpers";

/**
 * Manage the Sessions-table column order and rows-per-page preferences
 * for the active org. Falls back to Sessions defaults when nothing is
 * saved; save callbacks are silent no-ops when no org is active.
 */
export function useSessionTablePreferences() {
  const { currentOrganization } = useAuth();

  const configQuery = useSearchTablePreferences(
    "session_search_table_preferences",
  );
  const updateMutation = useUpdateSearchTablePreferences(
    "session_search_table_preferences",
  );

  const orgPreferences = useOrgPreferences(
    configQuery.data,
    currentOrganization?.org_id,
  );

  const preferences = createPreferencesWithDefaults(
    orgPreferences,
    DEFAULT_TABLE_COLUMNS[TableType.Sessions],
    DEFAULT_ROWS_PER_PAGE,
  );

  const { saveColumns, saveRowsPerPage, savePreferences, clearError } =
    useCreatePreferenceCallbacks(updateMutation, currentOrganization?.org_id);

  return {
    preferences,
    saveColumns,
    saveRowsPerPage,
    savePreferences,
    isLoading: configQuery.isLoading,
    isSaving: updateMutation.isPending,
    error: updateMutation.error,
    clearError,
  };
}
